
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26.458 26.458","width":"24","height":"24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.711 25.063c-1.361-.636-2.491-1.173-2.51-1.193-.02-.02.244-.145.586-.277.342-.133.678-.297.748-.363.078-.075-.207-.455-.751-.998-1.514-1.513-3.934-2.545-6.437-2.747L.265 19.4V3.51h18.494l.037-1.623.036-1.623 3.677 3.29c2.022 1.81 3.68 3.34 3.685 3.398.004.059-1.663 1.605-3.705 3.437l-3.714 3.33-.036-1.667-.037-1.667-7.948-.018c-7.46-.017-7.833-.007-6.06.166 6.982.68 11.644 2.6 16.005 6.593l1.215 1.112.642-.565.641-.566v1.131c0 .623-.039 1.911-.085 2.864l-.085 1.732-2.684-.084c-1.476-.045-2.706-.103-2.733-.128-.028-.024.232-.311.576-.637l.627-.593-1.033-.923c-3.91-3.496-8.402-5.195-14.388-5.444-1.426-.06-1.515-.051-.717.065 2.454.357 5.351 1.563 7.112 2.96.944.75 2.16 2.09 2.691 2.969l.343.566.819-.322.819-.322-.113.303c-.137.368-2.095 4.912-2.133 4.948-.014.015-1.14-.494-2.502-1.13z"}})])
          )
        }
      }
    